import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { AuthService } from '../auth.service';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = () => {
  const router: Router = inject(Router);

  // Check the authentication status
  const auth = inject(AuthService).auth();

  if (auth.currentUser !== null) {
    // If the user is authenticated...
    return of(router.parseUrl(''));
  }

  // Allow the access
  return of(true);
};
